window.__fast_options = { display_popular_on_empty_term: true,
  parseAcProductPrice: function(price) {
    let currency = Shopify.currency.active;
    const currentLanguage = Shopify.locale;
    if (currency && currency === 'CAD') {
      if (currentLanguage && currentLanguage == 'fr') {
        price = price.replace(/[^\d.]/g, '');
        price = parseFloat(price).toFixed(2).replace('.00', '');
        price = `${price} $`;
      } else {
        return price.replace('CAD', '').replace('.00', '');
      }
    }
    return price;
  },
  parseAcProductCompare: function(price) {
    let currency = Shopify.currency.active;
    const currentLanguage = Shopify.locale;
    if (currency && currency === 'CAD') {
      if (currentLanguage && currentLanguage == 'fr') {
        price = price.replace(/[^\d.]/g, '');
        price = parseFloat(price).toFixed(2).replace('.00', '');
        price = `${price} $`;
      } else {
        return price.replace('CAD', '').replace('.00', '');
      }
    }
    return price;
  },
  parseUpsellProductPrice: function(price) {
    let currency = Shopify.currency.active;
    const currentLanguage = Shopify.locale;
    if (currency && currency === 'CAD') {
      if (currentLanguage && currentLanguage == 'fr') {
        price = price.replace(/[^\d.]/g, '');
        price = parseFloat(price).toFixed(2).replace('.00', '');
        price = `${price} $`;
      } else {
        return price.replace('CAD', '').replace('.00', '');
      }
    }
    return price;
  },
  parseUpsellComparePrice: function(price) {
    let currency = Shopify.currency.active;
    const currentLanguage = Shopify.locale;
    if (currency && currency === 'CAD') {
      if (currentLanguage && currentLanguage == 'fr') {
        price = price.replace(/[^\d.]/g, '');
        price = parseFloat(price).toFixed(2).replace('.00', '');
        price = `${price} $`;
      } else {
        return price.replace('CAD', '').replace('.00', '');
      }
    }
    return price;
  }
};

window.__fastOptions = {
  parseProductPrice: function(price, isCompare) {
    let currency = Shopify.currency.active;
    const currentLanguage = Shopify.locale;
    if (currency && currency === 'CAD') {
      if (currentLanguage && currentLanguage == 'fr') {
        price = price.replace(/[^\d.]/g, '');
        price = parseFloat(price).toFixed(2).replace('.00', '');
        price = `${price} $`;
      } else {
        return price.replace('.00', '');
      }
    }
    return price;
  },
  parseComparePrice: function(price) {
    let currency = Shopify.currency.active;
    const currentLanguage = Shopify.locale;
    if (currency && currency === 'CAD') {
      if (currentLanguage && currentLanguage == 'fr') {
        price = price.replace(/[^\d.]/g, '');
        price = parseFloat(price).toFixed(2).replace('.00', '');
        price = `${price} $`;
      } else {
        return price.replace('.00', '');
      }
    }
    return price;
  },
  parse_slider_price: function(price) {
    let currency = Shopify.currency.active;
    const currentLanguage = Shopify.locale;
    if (currency && currency === 'CAD') {
      if (currentLanguage && currentLanguage == 'fr') {
        price = price.replace(/[^\d.]/g, '').replace('CAD', '').replace('.00', '');
        price = `${price}$`;
      } else {
        return price.replace('CAD', '').replace('.00', '');
      }
    }
    return price;
  }
};


 /* get all products to loop on */
  function getProductElements(element) {
      return [...element.querySelectorAll(`.fs-results-product-card`)];
  }


function getSecondImageFromAttributes(attributes) {
  for (let key in attributes) {
    if (attributes[key][0] === "Product images") {
      const images = attributes[key][1];
      return images.length > 1 ? images[1] : null;
    }
  }
  return null;
}

function handleNoSizeProduct(productElement, data) {
    const hasNoSize = Object.keys(data.attributes || {}).some(key => {
        return data.attributes[key][0] === "Size" && data.attributes[key][1][0] === "nosz";
    });
    if (!hasNoSize) return;
    productElement.classList.add("fs-nosz-hidden");
    const quickBuyBtn = productElement.querySelector('.fs_atc_btn');
    if (quickBuyBtn) {
        quickBuyBtn.addEventListener('click', function () {
            const optionsElement = productElement.querySelector('.actions .options');
            if (optionsElement) {
                optionsElement.style.setProperty('display', 'none', 'important');
            }
            const noszButton = productElement.querySelector('.options .option');
            if (noszButton) {
                noszButton.click();
            }
            const statusContainer = productElement.querySelector('.fs-cart-status-container header');
            if (statusContainer && statusContainer.textContent.trim().toUpperCase() === 'SELECT A SIZE') {
                statusContainer.style.display = 'none';
                const closeBtn = productElement.querySelector('.fs_atc_close');
                if (closeBtn) {
                    closeBtn.style.display = 'none';
                }
            }
        });
    }
}
/* ------------------------------------------------------------------ *
 * Local size conversion (Collection / SERP grid ATC size options)
 * Mirrors the behaviour already implemented on the PDP / cart / quick
 * view swatches (see snippets/swatch_size_new.liquid,
 * sections/kg-main-product.liquid). The Fast Simon grid renders its
 * size options client side, so the server side Liquid conversion never
 * runs there — we re-apply it here from settings.
 * ------------------------------------------------------------------ */var LOCAL_SIZE_CONVERSION_ENABLED = true;
var LOCAL_SIZE_CONVERSION_DATA = [];
try {
    LOCAL_SIZE_CONVERSION_DATA = JSON.parse("[\n  {\n    \"product_tags\": \"Ladies,9\",\n    \"size\": \"XS\",\n    \"us_size\": \"XS\"\n  },\n  {\n    \"product_tags\": \"Ladies,9\",\n    \"size\": \"S\",\n    \"us_size\": \"S\"\n  },\n  {\n    \"product_tags\": \"Ladies,9\",\n    \"size\": \"M\",\n    \"us_size\": \"M\"\n  },\n  {\n    \"product_tags\": \"Ladies,9\",\n    \"size\": \"L\",\n    \"us_size\": \"L\"\n  },\n  {\n    \"product_tags\": \"Ladies,9\",\n    \"size\": \"XL\",\n    \"us_size\": \"XL\"\n  },\n  {\n    \"product_tags\": \"Ladies,9\",\n    \"size\": \"XXL\",\n    \"us_size\": \"XXL\"\n  },\n  {\n    \"product_tags\": \"Ladies,9\",\n    \"size\": \"S\/M\",\n    \"us_size\": \"S\/M\"\n  },\n  {\n    \"product_tags\": \"Ladies,9\",\n    \"size\": \"36\/37\",\n    \"us_size\": \"6\/7\"\n  },\n  {\n    \"product_tags\": \"Ladies,9\",\n    \"size\": \"38\/39\",\n    \"us_size\": \"8\/9\"\n  },\n  {\n    \"product_tags\": \"Ladies,9\",\n    \"size\": \"40\/41\",\n    \"us_size\": \"10\/11\"\n  },\n  {\n    \"product_tags\": \"Ladies,9\",\n    \"size\": \"40\/42\",\n    \"us_size\": \"10\/11\"\n  },\n  {\n    \"product_tags\": \"Ladies,9\",\n    \"size\": \"41\/42\",\n    \"us_size\": \"11\/12\"\n  },\n  {\n    \"product_tags\": \"Ladies,9\",\n    \"size\": \"35\",\n    \"us_size\": \"5\"\n  },\n  {\n    \"product_tags\": \"Ladies,9\",\n    \"size\": \"35.5\",\n    \"us_size\": \"5.5\"\n  },\n  {\n    \"product_tags\": \"Ladies,9\",\n    \"size\": \"36\",\n    \"us_size\": \"6\"\n  },\n  {\n    \"product_tags\": \"Ladies,9\",\n    \"size\": \"36.5\",\n    \"us_size\": \"6.5\"\n  },\n  {\n    \"product_tags\": \"Ladies,9\",\n    \"size\": \"37\",\n    \"us_size\": \"7\"\n  },\n  {\n    \"product_tags\": \"Ladies,9\",\n    \"size\": \"37.5\",\n    \"us_size\": \"\"\n  },\n  {\n    \"product_tags\": \"Ladies,9\",\n    \"size\": \"38\",\n    \"us_size\": \"7.5\"\n  },\n  {\n    \"product_tags\": \"Ladies,9\",\n    \"size\": \"38.5\",\n    \"us_size\": \"8\"\n  },\n  {\n    \"product_tags\": \"Ladies,9\",\n    \"size\": \"39\",\n    \"us_size\": \"8.5\"\n  },\n  {\n    \"product_tags\": \"Ladies,9\",\n    \"size\": \"39.5\",\n    \"us_size\": \"\"\n  },\n  {\n    \"product_tags\": \"Ladies,9\",\n    \"size\": \"40\",\n    \"us_size\": \"9\"\n  },\n  {\n    \"product_tags\": \"Ladies,9\",\n    \"size\": \"40.5\",\n    \"us_size\": \"9.5\"\n  },\n  {\n    \"product_tags\": \"Ladies,9\",\n    \"size\": \"41\",\n    \"us_size\": \"10\"\n  },\n  {\n    \"product_tags\": \"Ladies,9\",\n    \"size\": \"41.5\",\n    \"us_size\": \"10.5\"\n  },\n  {\n    \"product_tags\": \"Ladies,9\",\n    \"size\": \"42\",\n    \"us_size\": \"11\"\n  },\n  {\n    \"product_tags\": \"Ladies,9\",\n    \"size\": \"42.5\",\n    \"us_size\": \"11.5\"\n  },\n  {\n    \"product_tags\": \"Ladies,9\",\n    \"size\": \"43\",\n    \"us_size\": \"12\"\n  },\n  {\n    \"product_tags\": \"MENS\",\n    \"size\": \"XXS\",\n    \"us_size\": \"XXS\"\n  },\n  {\n    \"product_tags\": \"MENS\",\n    \"size\": \"XS\",\n    \"us_size\": \"XS\"\n  },\n  {\n    \"product_tags\": \"MENS\",\n    \"size\": \"S\",\n    \"us_size\": \"S\"\n  },\n  {\n    \"product_tags\": \"MENS\",\n    \"size\": \"M\",\n    \"us_size\": \"M\"\n  },\n  {\n    \"product_tags\": \"MENS\",\n    \"size\": \"L\",\n    \"us_size\": \"L\"\n  },\n  {\n    \"product_tags\": \"MENS\",\n    \"size\": \"XL\",\n    \"us_size\": \"XL\"\n  },\n  {\n    \"product_tags\": \"MENS\",\n    \"size\": \"XXL\",\n    \"us_size\": \"XXL\"\n  },\n  {\n    \"product_tags\": \"MENS\",\n    \"size\": \"XXXL\",\n    \"us_size\": \"XXXL\"\n  },\n  {\n    \"product_tags\": \"MENS\",\n    \"size\": \"39\",\n    \"us_size\": \"6\"\n  },\n  {\n    \"product_tags\": \"MENS\",\n    \"size\": \"39.5\",\n    \"us_size\": \"6.5\"\n  },\n  {\n    \"product_tags\": \"MENS\",\n    \"size\": \"40\",\n    \"us_size\": \"7\"\n  },\n  {\n    \"product_tags\": \"MENS\",\n    \"size\": \"40.5\",\n    \"us_size\": \"7.5\"\n  },\n  {\n    \"product_tags\": \"MENS\",\n    \"size\": \"41\",\n    \"us_size\": \"8\"\n  },\n  {\n    \"product_tags\": \"MENS\",\n    \"size\": \"41.5\",\n    \"us_size\": \"8.5\"\n  },\n  {\n    \"product_tags\": \"MENS\",\n    \"size\": \"42\",\n    \"us_size\": \"9\"\n  },\n  {\n    \"product_tags\": \"MENS\",\n    \"size\": \"42.5\",\n    \"us_size\": \"\"\n  },\n  {\n    \"product_tags\": \"MENS\",\n    \"size\": \"43\",\n    \"us_size\": \"10\"\n  },\n  {\n    \"product_tags\": \"MENS\",\n    \"size\": \"43.5\",\n    \"us_size\": \"10\"\n  },\n  {\n    \"product_tags\": \"MENS\",\n    \"size\": \"44\",\n    \"us_size\": \"11\"\n  },\n  {\n    \"product_tags\": \"MENS\",\n    \"size\": \"44.5\",\n    \"us_size\": \"10.5\"\n  },\n  {\n    \"product_tags\": \"MENS\",\n    \"size\": \"45\",\n    \"us_size\": \"12\"\n  },\n  {\n    \"product_tags\": \"MENS\",\n    \"size\": \"45.5\",\n    \"us_size\": \"11.5\"\n  },\n  {\n    \"product_tags\": \"MENS\",\n    \"size\": \"46\",\n    \"us_size\": \"13\"\n  },\n  {\n    \"product_tags\": \"MENS\",\n    \"size\": \"46.5\",\n    \"us_size\": \"\"\n  },\n  {\n    \"product_tags\": \"MENS\",\n    \"size\": \"47\",\n    \"us_size\": \"13\"\n  },\n  {\n    \"product_tags\": \"MENS\",\n    \"size\": \"47.5\",\n    \"us_size\": \"\"\n  },\n  {\n    \"product_tags\": \"MENS\",\n    \"size\": \"48\",\n    \"us_size\": \"\"\n  }\n]");
} catch (e) {
    console.error('Local size conversion JSON parse error:', e);
}function normalizeSizeValue(value) {
    return String(value == null ? '' : value).trim();
}

/* pull the product's tags out of the Fast Simon product data (data.attributes
 * holds entries like ["Tag", ["AW26","MENS","SYNTHETIC", ...]]) */
function getLocalSizeProductTags(data) {
    if (!data || !data.attributes) return [];
    for (var key in data.attributes) {
        var attr = data.attributes[key];
        if (attr && attr[0] === 'Tag') return attr[1] || [];
    }
    return [];
}

/* does a conversion entry's product_tags overlap the product's tags? */
function localSizeEntryMatchesTags(entry, productTags) {
    if (!entry || !entry.product_tags || !productTags || !productTags.length) return false;
    var entryTags = String(entry.product_tags).split(',').map(function (t) {
        return t.trim().toUpperCase();
    });
    return productTags.some(function (t) {
        return entryTags.indexOf(normalizeSizeValue(t).toUpperCase()) > -1;
    });
}

/* find the conversion entry that matches a Shopify size value.
 * Prefer an entry whose product_tags match the product (so MENS vs LADIES
 * sizes that share an EU number resolve correctly), then fall back to a
 * plain size-only match. */
function findLocalSizeEntry(sizeValue, productTags) {
    var size = normalizeSizeValue(sizeValue);
    if (!size || !Array.isArray(LOCAL_SIZE_CONVERSION_DATA)) return null;
    var target = size.toUpperCase();
    var bySize = LOCAL_SIZE_CONVERSION_DATA.filter(function (item) {
        return normalizeSizeValue(item && item.size).toUpperCase() === target;
    });
    if (!bySize.length) return null;
    var tagged = bySize.find(function (item) {
        return localSizeEntryMatchesTags(item, productTags);
    });
    return tagged || bySize[0];
}

/* build a display string e.g. "US 5 / UK 3" from a matched entry */
function buildLocalSizeConversion(sizeValue, productTags) {
    var entry = findLocalSizeEntry(sizeValue, productTags);
    if (!entry) return '';
    var parts = [];
    for (var key in entry) {
        if (!Object.prototype.hasOwnProperty.call(entry, key)) continue;
        // only the region size keys (us_size, uk_size, eu_size, ...) carry a value
        if (key.slice(-5) === '_size' && entry[key]) {
            var label = key.replace('_size', '').toUpperCase();
            // strip any region prefix already present in the value (e.g. "US 5" -> "5")
            var val = normalizeSizeValue(entry[key]).replace(/^[A-Za-z]+\s*/, '');
            if (val) parts.push(label + ' ' + val);
        }
    }
    return parts.join(' / ');
}

/* append the local size to each Shopify size option inside the grid ATC.
 * The option is a clickable add-to-cart button, so we must NOT add a child
 * element (that would change the click target and break Fast Simon's handler).
 * Instead we append to the button's text content, e.g. "39" -> "39 / US 6 / UK 5". */

/* tracks the exact text node WE appended to each option, so re-renders can be
 * detected and repaired. On sort/filter, Svelte reuses the same .option element
 * but deletes and re-creates ITS OWN text nodes, which land AFTER our stale
 * conversion node — turning "35 / US 5" into "/ US 535". It can also reuse the
 * element for a DIFFERENT size, leaving a wrong conversion. A plain textContent
 * guard can't tell those apart from a healthy option, so we track our node and
 * health-check it on every pass. */
var localSizeAppendedNodes = new WeakMap();

function applyLocalSizeConversion(productElement, data) {
    if (!LOCAL_SIZE_CONVERSION_ENABLED) return;
    if (!Array.isArray(LOCAL_SIZE_CONVERSION_DATA) || !LOCAL_SIZE_CONVERSION_DATA.length) return;

    var productTags = getLocalSizeProductTags(data);
    var optionEls = productElement.querySelectorAll('.actions .options .option');
    optionEls.forEach(function (optionEl) {
        var appended = localSizeAppendedNodes.get(optionEl);
        if (!appended || appended.parentNode !== optionEl) {
            // adopt a conversion node from an earlier pass we lost track of
            // (identified by our unique " / " prefix — Svelte's own size text
            // never starts with it; range sizes like "36/37" have no spaces)
            appended = null;
            for (var i = 0; i < optionEl.childNodes.length; i++) {
                var node = optionEl.childNodes[i];
                if (node.nodeType === 3 && node.textContent.indexOf(' / ') === 0) {
                    appended = node;
                    break;
                }
            }
        }

        if (appended) {
            // health check: our node must still be the LAST child (Svelte
            // re-creating its text nodes pushes them after ours) and must still
            // match the option's current size (Svelte may reuse the element for
            // a different size). Healthy -> no mutation (keeps the observer
            // loop-safe). Unhealthy -> strip our node and rebuild below.
            var baseText = normalizeSizeValue(optionEl.textContent.replace(appended.textContent, ''));
            if (optionEl.lastChild === appended &&
                baseText &&
                appended.textContent === ' / ' + buildLocalSizeConversion(baseText, productTags)) {
                return;
            }
            optionEl.removeChild(appended);
            localSizeAppendedNodes.delete(optionEl);
        }

        // text is pristine here (our node removed / never added), so this is
        // the clean size value
        var rawSize = normalizeSizeValue(optionEl.dataset.value || optionEl.textContent);
        if (!rawSize) return;

        // bare EU numbers get the "EU " prefix from the ::before in kg-fs-css
        // (same flag as the size filter), so the quick-add reads
        // "EU 35 / US 5" like the filter does. Set before the conversion
        // check so a size with no US entry (37.5) still reads "EU 37.5".
        var isBareEu = BARE_EU_SIZE.test(rawSize);
        if (isBareEu) {
            if (!optionEl.hasAttribute('data-kg-size-eu')) optionEl.setAttribute('data-kg-size-eu', '');
        } else if (optionEl.hasAttribute('data-kg-size-eu')) {
            optionEl.removeAttribute('data-kg-size-eu');
        }

        var converted = buildLocalSizeConversion(rawSize, productTags);
        // nothing of ours to show on this option (a range like "36/37" with no
        // table entry) — leave it exactly as Fast Simon rendered it
        if (!converted && !isBareEu) return;

        if (converted) {
            // append as a text node (not an element) so the button stays a single
            // clickable target and its add-to-cart behaviour is preserved
            var conversionNode = document.createTextNode(' / ' + converted);
            optionEl.appendChild(conversionNode);
            localSizeAppendedNodes.set(optionEl, conversionNode);
        }

        // ADA: the option is a bare clickable <span>; give it accessible button
        // semantics and a readable label (so screen readers announce
        // "Size EU 39, US 8.5, UK 6" instead of "39 slash US 8.5 slash UK 6").
        // Applies to the "EU"-prefixed sizes with no US entry too ("EU 37.5"),
        // so what is announced matches what is shown.
        if (!optionEl.getAttribute('role')) optionEl.setAttribute('role', 'button');
        if (!optionEl.hasAttribute('tabindex')) optionEl.setAttribute('tabindex', '0');
        // change-guarded: an unconverted "EU" size reaches this point on every
        // pass, and a same-value setAttribute would still wake the observer
        var optionLabel = 'Size EU ' + rawSize + (converted ? ', ' + converted.split(' / ').join(', ') : '');
        if (optionEl.getAttribute('aria-label') !== optionLabel) optionEl.setAttribute('aria-label', optionLabel);
        // allow keyboard activation (Enter / Space) for the click-driven handler
        if (optionEl.dataset.localSizeKeyboard !== 'true') {
            optionEl.dataset.localSizeKeyboard = 'true';
            optionEl.addEventListener('keydown', function (event) {
                if (event.key === 'Enter' || event.key === ' ' || event.key === 'Spacebar') {
                    event.preventDefault();
                    optionEl.click();
                }
            });
        }
    });
}

/* ------------------------------------------------------------------ *
 * Local size conversion — SERP size FILTER options
 * Same conversion table as the grid ATC options above, but display only.
 *
 * The converted value is rendered by a CSS ::after fed from a data
 * attribute, NOT by inserting text or elements into the option. That
 * keeps the label's textContent and the checkbox value byte-for-byte
 * unchanged, so Fast Simon's filter matching / removable tags / URL
 * state are all untouched — we are strictly adding a visual suffix.
 * ------------------------------------------------------------------ */

/* filter containers to annotate, matched against the container id and
 * data-filter-id (lowercased). KG CA runs EN + FR, hence 'taille'. */
var FILTER_SIZE_KEYS = ['size', 'taille'];

/* The ::after rule that renders data-kg-size-conv lives in
 * snippets/kg-fs-css.liquid, inside <style id="fs-ssr-custom-styles"> — Fast
 * Simon clones that element into its shadow root, so the rules reach the
 * filter options and the removable tags from there. */

function isSizeFilterContainer(container) {
    var id = String(container.id || '').toLowerCase();
    var filterId = String(container.getAttribute('data-filter-id') || '').toLowerCase();
    return FILTER_SIZE_KEYS.some(function (key) {
        return id.indexOf(key) > -1 || filterId.indexOf(key) > -1;
    });
}

/* the label holds the size plus a result count ("39 (12)"); drop the count
 * so only the size value is looked up */
function getFilterOptionSize(labelEl) {
    var clone = labelEl.cloneNode(true);
    clone.querySelectorAll('.fs-serp-filter-count, .serp-filter-count, .filter-count')
        .forEach(function (countEl) { countEl.remove(); });
    return normalizeSizeValue(clone.textContent);
}

/* write (or clear) the display-only conversion on a single label / chip.
 * No product context exists at filter level, so tags can't disambiguate
 * MENS vs LADIES entries that share an EU number — findLocalSizeEntry
 * falls back to the first matching row. */
/* a bare EU number ("41", "37.5"), i.e. a size Fast Simon returned without a
 * display name. Values already renamed in the Fast Simon dashboard
 * ("EU 40 / US 9") and non-size chips never match. */
var BARE_EU_SIZE = /^\d+(?:\.\d+)?$/;

function annotateSizeLabel(el, rawSize) {
    var converted = rawSize ? buildLocalSizeConversion(rawSize, []) : '';
    // Fast Simon's own renamed sizes carry the "EU" prefix; a bare number
    // gets it from the ::before in kg-fs-css so the whole size column reads
    // the same ("EU 41 / US 10"). Independent of the conversion table, so a
    // size with no US entry (37.5) still reads "EU 37.5".
    var isBareEu = BARE_EU_SIZE.test(rawSize);

    // Svelte reuses these elements across re-renders, so stale attributes
    // must be cleared rather than left in place. Attributes are only written
    // when they actually change, so the grid's MutationObserver isn't
    // re-triggered by our own writes.
    if (isBareEu) {
        if (!el.hasAttribute('data-kg-size-eu')) el.setAttribute('data-kg-size-eu', '');
    } else if (el.hasAttribute('data-kg-size-eu')) {
        el.removeAttribute('data-kg-size-eu');
    }

    if (!converted) {
        if (el.hasAttribute('data-kg-size-conv')) el.removeAttribute('data-kg-size-conv');
        // ::before / ::after content is not reliably announced, so state it explicitly
        var bareLabel = isBareEu ? 'Size EU ' + rawSize : null;
        if (bareLabel && el.getAttribute('aria-label') !== bareLabel) {
            el.setAttribute('aria-label', bareLabel);
        } else if (!bareLabel && /^Size EU /.test(el.getAttribute('aria-label') || '')) {
            // only ever remove a label we wrote ourselves
            el.removeAttribute('aria-label');
        }
        return;
    }

    if (el.getAttribute('data-kg-size-conv') === converted) return;

    el.setAttribute('data-kg-size-conv', converted);
    el.setAttribute('aria-label', 'Size EU ' + rawSize + ', ' + converted.split(' / ').join(', '));
}

function applyFilterSizeConversion(element) {
    if (!LOCAL_SIZE_CONVERSION_ENABLED || !element) return;
    if (!Array.isArray(LOCAL_SIZE_CONVERSION_DATA) || !LOCAL_SIZE_CONVERSION_DATA.length) return;

    element.querySelectorAll('.fs-category-container').forEach(function (container) {
        if (!isSizeFilterContainer(container)) return;
        container.querySelectorAll('.checkbox-label, .fs-checkbox-label').forEach(function (labelEl) {
            annotateSizeLabel(labelEl, getFilterOptionSize(labelEl));
        });
    });
}

/* Applied-filter chips ("FILTRES APPLIQUÉS"). The chips carry no filter id, so
 * they self-select: a chip is annotated only when its value matches a row in
 * the conversion table, which colours / materials / categories never do. The
 * chip text and its remove button are left untouched. */
function applyRemovableTagSizeConversion(element) {
    if (!LOCAL_SIZE_CONVERSION_ENABLED || !element) return;
    if (!Array.isArray(LOCAL_SIZE_CONVERSION_DATA) || !LOCAL_SIZE_CONVERSION_DATA.length) return;

    element.querySelectorAll('.removable-tag-text, .fs-removable-tag-text').forEach(function (tagEl) {
        annotateSizeLabel(tagEl, normalizeSizeValue(tagEl.textContent));
    });
}

/* ------------------------------------------------------------------ *
 * Tag-based filter values — underscores to spaces
 * The TYPE filter is built from Shopify tags (KG_CA_Womens_Shoes_Bestsellers).
 * Fast Simon strips the configured prefix but keeps the underscores, so the
 * option reads "Shoes_Bestsellers" and the applied-filter chip repeats it.
 * Only the text nodes are rewritten; the checkbox value, the chip's
 * data-original-facet-value and the URL keep the raw tag, so filtering and
 * tag removal are unaffected. Svelte re-renders are caught by the hooks
 * below, which re-run this on every filters / removable-tags update.
 * ------------------------------------------------------------------ */

/* Fast Simon's tag filters are the "Isp-tag-*" fields */
function isTagFilterContainer(container) {
    var filterId = String(container.getAttribute('data-filter-id') || '').toLowerCase();
    return filterId.indexOf('isp-tag-') === 0;
}

function replaceUnderscoresInTextNodes(el) {
    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null, false);
    var node;
    while ((node = walker.nextNode())) {
        if (node.textContent.indexOf('_') === -1) continue;
        node.textContent = node.textContent.replace(/_+/g, ' ');
    }
}

function applyTagFilterLabelFormat(element) {
    if (!element) return;

    element.querySelectorAll('.fs-category-container').forEach(function (container) {
        if (!isTagFilterContainer(container)) return;
        container.querySelectorAll('.filters-option-text, .fs-serp-filter-text').forEach(replaceUnderscoresInTextNodes);
    });

    // chips carry no filter id; an underscore only ever comes from a tag value
    element.querySelectorAll('.removable-tag-text, .fs-removable-tag-text').forEach(replaceUnderscoresInTextNodes);
}

/* ------------------------------------------------------------------ *
 * Applied-filter price chip — drop the currency code
 * The price chip is the one tag Fast Simon builds with Intl, so it comes
 * back carrying the ISO code ("$75.00 CAD", or "75,00 $ CA" in FR) while
 * every other price on the CA storefront reads "$75" / "75 $" — the same
 * convention parse_slider_price applies to the slider handles above.
 *
 * Only the chip's own text nodes are rewritten, so the remove button and
 * the size-conversion attribute (data-kg-size-conv) are left in place, and
 * Fast Simon keys tag removal off its own tag data rather than off this
 * label — the filter state and the URL are untouched.
 * ------------------------------------------------------------------ */

/* a chip is a price chip only if it carries a currency marker AND a digit,
 * which colours / sizes / categories never do */
var PRICE_TAG_MARKER = /(?:CAD\b|CA\s*\$|\$)/;

function formatRemovableTagPrice(text) {
    var out = text
        .replace(/CA\s*\$/g, '$')        // Intl "CA$75.00"
        .replace(/\$\s*CA\b/g, '$')      // FR-CA Intl "75,00 $ CA"
        .replace(/\bCAD\b/g, '')         // trailing ISO code
        .replace(/([.,])00(?!\d)/g, '')  // whole-dollar amounts: "$75.00" -> "$75"
        .replace(/\s+/g, ' ')
        .replace(/\s*([-–—])\s*/g, ' $1 ')
        .trim();

    // FR-CA puts the sign after the amount ("75 $"), matching the price
    // inputs (see snippets/kg-fs-css.liquid) and parse_slider_price above.
    // Amounts already written that way have no "$" in front to move.
    if (String(Shopify.locale || '').toLowerCase() === 'fr') {
        out = out.replace(/\$\s*(\d[\d\s.,]*\d|\d)/g, '$1 $');
    }
    return out;
}

function applyRemovableTagPriceFormat(element) {
    if (!element || !window.Shopify || !Shopify.currency) return;
    if (Shopify.currency.active !== 'CAD') return;

    element.querySelectorAll('.removable-tag-text, .fs-removable-tag-text').forEach(function (tagEl) {
        // the chip renders as "Price: $75.00 CAD - $517.00 CAD" — the prefix and
        // the amounts can be one text node or split across nested nodes
        // depending on the Fast Simon build, so walk every descendant text node.
        var walker = document.createTreeWalker(tagEl, NodeFilter.SHOW_TEXT, null, false);
        var node;
        while ((node = walker.nextNode())) {
            var text = node.nodeValue;
            if (!PRICE_TAG_MARKER.test(text) || !/\d/.test(text)) continue;
            var formatted = formatRemovableTagPrice(text);
            // Svelte reuses these nodes across re-renders and the hook fires on
            // every one, so only write when the value actually changes.
            if (formatted !== text) node.nodeValue = formatted;
        }
    });
}

/* Fast Simon re-renders the grid on pagination / filter / sort / quick-add and
 * adds (or resets) product cards AFTER the serp-product-grid hook has fired. To
 * keep the size conversion present on every render we (1) remember the latest
 * products map and (2) watch the grid's shadow root for changes, re-processing
 * all cards. */
var LOCAL_SIZE_PRODUCTS = {};
var localSizeObserverAttached = false;
var localSizeReprocessTimer = null;

/* re-apply the conversion to every card currently in the grid root */
function reprocessLocalSizes(rootNode) {
    if (!LOCAL_SIZE_CONVERSION_ENABLED || !rootNode) return;
    rootNode.querySelectorAll('.fs-results-product-card').forEach(function (card) {
        applyLocalSizeConversion(card, LOCAL_SIZE_PRODUCTS[card.dataset.productId]);
    });
}

/* attach a single debounced observer on the (stable) grid root node */
function ensureLocalSizeObserver(element) {
    if (localSizeObserverAttached || !LOCAL_SIZE_CONVERSION_ENABLED || !element) return;
    // getRootNode() returns the Fast Simon shadow root, which persists across
    // grid re-renders (the inner cards are what get replaced/reset).
    var rootNode = element.getRootNode ? element.getRootNode() : document;
    if (!rootNode || typeof MutationObserver === 'undefined') return;
    localSizeObserverAttached = true;
    var observer = new MutationObserver(function () {
        // debounce: batch the burst of mutations a re-render produces.
        // The text-based guard in applyLocalSizeConversion makes this safe
        // against feedback loops (already-converted options are skipped).
        clearTimeout(localSizeReprocessTimer);
        localSizeReprocessTimer = setTimeout(function () {
            reprocessLocalSizes(rootNode);
        }, 150);
    });
    observer.observe(rootNode, { childList: true, subtree: true });
}

function updatePageTitle(element) {
    const pageTitle = element.closest('#fast-simon-app')?.querySelector('.fs-page-title-container .titleWrapper .title');
    if (pageTitle) {

    }
}

function updateNoResultsMessage(element) {
    const noResultsEl = element.querySelector('.fs-no-results');
    if (noResultsEl) {
        noResultsEl.outerHTML = `No results found. Check out some of our best sellers below!`;
    }
}

function updateResultsDisplay(element, totalResults) {
    const totalResultsEl = element.querySelector('.fs-num-results');
    const categoryEl = element.querySelector('.query-cat-name');
    const titleWrapCategory = element.closest('#fast-simon-app')?.querySelector('.fs-page-title-container');

    if (totalResultsEl && totalResults) {
        totalResultsEl.textContent = '(' + totalResults + ')';
        document.getElementById('fast-simon-serp-app')?.shadowRoot?.getElementById('initial-load-fs-num-results')?.remove?.();
        totalResultsEl.style.setProperty('display', 'block', 'important');
    } else if (totalResults === 0 && categoryEl && !element.querySelector('.fs-num-results')) {
        categoryEl.insertAdjacentHTML('afterend', `<div style="display: block !important;" class="fs-num-results svelte-cwrvb5">(0)</div>`);
    }

    // *** FIX FOR DUPLICATE RESULTS ***
    // Check if the title container *already has* a results count element before appending.
    if (titleWrapCategory && totalResultsEl && !titleWrapCategory.querySelector('.fs-num-results')) {
        titleWrapCategory.appendChild(totalResultsEl);
    }
}

function moveElementToTop(element) {
    let fsParent = document.querySelector('#fast-simon-serp-app');
    let description = document.querySelector('.kg_fs_collection_description');
    let descriptionText = description?.querySelector('p');
    let showBtn = document.querySelector('.fs_show_description');
    let titleWrap = element.querySelector('.titleWrapper');
    let collectionLinks = document.querySelector('.fs_collection_links');
    if(description && descriptionText && showBtn && titleWrap) {
        element.appendChild(description);
        titleWrap.appendChild(showBtn);
    }
    if(collectionLinks) {
        element.appendChild(collectionLinks);
    }
    fsParent?.parentNode?.insertBefore(element, fsParent);
    const icon = showBtn?.querySelector('svg');

    titleWrap.addEventListener('click', () => {
        // toggle visibility of description
        description.classList.toggle('active');

        // rotate svg icon
        icon.classList.toggle('rotated');
    });
}

// The description HTML is set on window by theme.liquid, which has the collection
// context that Liquid assets lack.
function addCategoryDescription(element) {
    if (!window.kgCategoryDescription) return;

    const titleWrapCategory = element?.classList?.contains('fs-page-title-container')
        ? element
        : element?.closest('#fs-serp-app')?.querySelector('.fs-page-title-container');
    if (!titleWrapCategory || titleWrapCategory.querySelector('.fs_category_descriptoin_cstm')) return;

    // The collection h1 that Fast Simon renders IS the accordion heading — we
    // attach to it rather than printing our own copy of the title, so the page
    // keeps exactly one h1 and its SEO / accessibility value is preserved.
    // two queries, not a selector list: a comma-separated list returns the first
    // match in DOCUMENT order, and .titleWrapper is an ancestor of .title — so
    // the list form would hand back the wrapper and the chevron would be
    // appended outside it, dropping onto its own line.
    const heading = titleWrapCategory.querySelector('.titleWrapper .title')
        || titleWrapCategory.querySelector('.titleWrapper');
    if (!heading) return;

    const body = document.createElement('div');
    body.className = 'fs_category_descriptoin_cstm kg-collection-desc__body';
    body.id = 'kg-collection-desc-body';
    body.hidden = true;
    body.innerHTML = window.kgCategoryDescription;

    // chevron lives in a real button so the control is focusable and announced;
    // the h1 keeps its text and stays a plain heading.
    const toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.className = 'kg-collection-desc__toggle';
    toggle.setAttribute('aria-expanded', 'false');
    toggle.setAttribute('aria-controls', body.id);
    toggle.setAttribute('aria-label', heading.textContent.trim());
    // Two icons swapped by CSS on aria-expanded, the way kurtgeiger.com does it.
    // Not a rotate: something in the stack blocks CSS transforms on inline SVG
    // here — even an inline transform computes to the identity matrix.
    toggle.insertAdjacentHTML('beforeend',
        '<svg class="kg-collection-desc__chevron kg-collection-desc__chevron--down" viewBox="0 0 512 512" ' +
        'width="14" height="14" aria-hidden="true" focusable="false"><path fill="currentColor" d="M233.4 ' +
        '406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 ' +
        '86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z"/></svg>' +
        '<svg class="kg-collection-desc__chevron kg-collection-desc__chevron--up" viewBox="0 0 512 512" ' +
        'width="14" height="14" aria-hidden="true" focusable="false"><path fill="currentColor" d="M233.4 ' +
        '105.4c12.5-12.5 32.8-12.5 45.3 0l192 192c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L256 173.3 ' +
        '86.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l192-192z"/></svg>');

    function setOpen(open) {
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        body.hidden = !open;
    }
    toggle.addEventListener('click', function (event) {
        event.stopPropagation();
        setOpen(toggle.getAttribute('aria-expanded') !== 'true');
    });
    // clicking the heading text toggles too, matching kurtgeiger.com. Added as a
    // listener so the h1's own markup is left untouched by us.
    heading.style.cursor = 'pointer';
    heading.addEventListener('click', function () {
        setOpen(toggle.getAttribute('aria-expanded') !== 'true');
    });

    (heading.parentElement || titleWrapCategory).appendChild(toggle);
    titleWrapCategory.appendChild(body);
    titleWrapCategory.classList.add('kg-has-collection-desc');
}

function enhanceMobileFilters(element) {
  if (window.innerWidth > 768) return;

  const filterContainers = element.querySelectorAll('.fs-category-container');

  filterContainers.forEach(container => {
    const categoryItems = container.querySelector('.category-items');
    if (!categoryItems) return;

    // Skip if already enhanced
    if (container.querySelector('.filter-pop-up')) return;

    // CREATE STRUCTURE
    const wrapper = document.createElement('div');
    wrapper.classList.add('filter-pop-up');

    const inner = document.createElement('div');
    inner.className = 'filter-inner';

    // HEADING WITH CLOSE BUTTON
    const heading = document.createElement('div');
    heading.className = 'filter-heading';

    const headingText = document.createElement('span');
    headingText.className = 'filter-heading-title';
    headingText.textContent = 'FILTER BY';

    //Close Button
    const closeButton = document.createElement('button');
    closeButton.className = 'filter-close-btn';
    closeButton.textContent = '×';
    closeButton.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      const filterCloseBtn = element.querySelector('.fs-modern-filters-close-button');
      if (filterCloseBtn) filterCloseBtn.click();
    });

    heading.appendChild(headingText);
    heading.appendChild(closeButton);

    // BACK BUTTON
    const backButton = document.createElement('button');
    backButton.className = 'filter-back-btn';
    backButton.innerHTML = `
    <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="chevron-left"
        class="svg-inline--fa fa-chevron-left fa-lg" role="img"
        xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" width="15" height="15" style="vertical-align: -0.2em;">
        <path fill="currentColor" d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z"></path>
    </svg>
    <span>Back</span>
    `;
    backButton.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();

      // Show all filter sections again
      element.querySelectorAll(".category-items").forEach(item => {
        item.classList.remove("collapsed");
      });

      element.querySelectorAll(".arrow").forEach(arrow => {
        arrow.classList.remove("rotate");
      });

      element.querySelectorAll(".fs-is-filters-open").forEach(openFilter => {
        openFilter.classList.remove("fs-is-filters-open");
      });
    });

    // TITLE of FILTER
    const filterTitleContainer = document.createElement('div');
    filterTitleContainer.className = 'filter-title-container';
    const filterTitle = container.querySelector('.fs-category-title span');
    if (filterTitle) {
      const filterTextTitle = document.createElement('div');
      filterTextTitle.className = 'filter-text-title';
      filterTextTitle.textContent = filterTitle.textContent;

      const clearButton = document.createElement('button');
      clearButton.className = 'filter-clear-btn';
      clearButton.textContent = 'CLEAR';
      clearButton.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();

        container.querySelectorAll('input[type="checkbox"]').forEach((checkbox) => {
        if (checkbox.checked) {
            checkbox.click();
        }
        });
      });
      filterTitleContainer.appendChild(filterTextTitle);
      filterTitleContainer.appendChild(clearButton);
    }
    // CONFIRM BUTTON
    const confirmContainer = document.createElement('div');
    confirmContainer.className = 'filter-confirm-container';

    const confirmButton = document.createElement('button');
    confirmButton.className = 'filter-confirm-btn';
    confirmButton.textContent = 'CONFIRM';
    confirmButton.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();

      element.querySelectorAll(".category-items").forEach(item => {
        item.classList.remove("collapsed");
      });

      element.querySelectorAll(".arrow").forEach(arrow => {
        arrow.classList.remove("rotate");
      });

      element.querySelectorAll(".fs-is-filters-open").forEach(openFilter => {
        openFilter.classList.remove("fs-is-filters-open");
      });
    });
    confirmContainer.appendChild(confirmButton);

    // WRAP STRUCTURE
    const parent = categoryItems.parentElement;
    parent.replaceChild(wrapper, categoryItems);
    inner.appendChild(heading);
    inner.appendChild(backButton);
    inner.appendChild(filterTitleContainer);
    inner.appendChild(categoryItems);
    inner.appendChild(confirmContainer);
    wrapper.appendChild(inner);
  });

  // ADD CLICK EVENTS TO FILTER TITLES
  element.querySelectorAll(".category-title").forEach((filterTitle) => {
    if (!filterTitle.classList.contains("cstm-event")) {
      filterTitle.classList.add("cstm-event");
      filterTitle.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();

        const container = filterTitle.closest(".category-container");
        const containerId = container.getAttribute("id");

        container.querySelector(".arrow")?.classList.remove("rotate");
        container.querySelector(".category-items")?.classList.remove("collapsed");
        container.classList.add("fs-is-filters-open");

        element.querySelectorAll(`.fs-is-filters-open:not(#${containerId})`).forEach(toCloseFilter => {
          toCloseFilter.querySelector(".arrow")?.classList.add("rotate");
          toCloseFilter.querySelector(".category-items")?.classList.add("collapsed");
          toCloseFilter.classList.remove("fs-is-filters-open");
        });
      });
    }
  });
}


function hooks() {
    SerpOptions.registerHook('serp-product-grid', ({ products, element }) => {

        // keep the latest products map + watch for later re-renders (pagination /
        // filter / sort / quick-add) so the size conversion is applied to every
        // card, not just the ones present when this hook first fired.
        LOCAL_SIZE_PRODUCTS = products || {};
        ensureLocalSizeObserver(element);

        for (const productElement of getProductElements(element)) {
            const productID = productElement.dataset.productId;
            const data = products[productID];
            // console.log(data);
            if(window.innerWidth >= 770) {
                if (typeof (data) !== "undefined" && data !== null && window.innerWidth > 770) {
                    //add hover second image
                    const imageWrapper = productElement.querySelector('.image-wrapper');
                    const currentImage = productElement.querySelector('.image-wrapper .product-image');
                    if (!imageWrapper || !currentImage) continue;
                    const originalImage = currentImage.src
                    const hoverImage = getSecondImageFromAttributes(data.attributes);
                    if (originalImage && hoverImage){
                        imageWrapper.addEventListener("mouseenter", () => {
                            currentImage.src = hoverImage;
                        });
                        imageWrapper.addEventListener("mouseleave", () => {
                            currentImage.src = originalImage;
                        });
                    }
                    // hide nosz button and aotumatic click on it
                    handleNoSizeProduct(productElement, data);

                    let imageWrap = productElement.querySelector('.fs-product-image-link');
                    let atcOptions = productElement.querySelector('.actions');
                    if(atcOptions && imageWrap) {
                        if(!imageWrap.querySelector('.fs_atc_btn')) {
                            let addBtn = document.createElement('button');
                            addBtn.classList.add('fs_atc_btn');
                            const labels = { fr: 'achat rapide', en: 'quick buy' };
                            addBtn.textContent = labels[window.fsLang] || labels.en;
                            let closeOptions = document.createElement('button');
                            closeOptions.classList.add('fs_atc_close');
                            closeOptions.textContent = 'x';
                            imageWrap.appendChild(addBtn);
                            atcOptions.appendChild(closeOptions);
                            addBtn.addEventListener('click', function(event) {
                                event.preventDefault();
                                event.stopPropagation();
                                // close any other product's open quick-buy panel
                                // so only one size selector is open at a time
                                var gridRoot = productElement.getRootNode ? productElement.getRootNode() : document;
                                gridRoot.querySelectorAll('.fs-results-product-card .actions').forEach(function (otherPanel) {
                                    if (otherPanel !== atcOptions) {
                                        otherPanel.style.display = 'none';
                                    }
                                });
                                atcOptions.style.display = 'block';
                            });
                            closeOptions.addEventListener('click', function(event) {
                                event.preventDefault();
                                event.stopPropagation();
                                atcOptions.style.display = 'none';
                            });
                        }
                        if(!imageWrap.contains(atcOptions)) {
                            imageWrap.appendChild(atcOptions);
                        }
                    }

                }
                let selectSizeBtn = productElement.querySelector('.fs-cart-status-container');
                if(selectSizeBtn) {
                    selectSizeBtn.innerHTML = 'ADD TO BAG';
                }
            }
            // add local size conversion next to the Shopify sizes (desktop + mobile)
            applyLocalSizeConversion(productElement, data);
        }
        let appParent = element.closest('#fs-serp-app');
        let noRes = appParent?.querySelector('.fs-no-results');
        if(noRes) {
            console.log('no results found');
            let query = appParent?.querySelector('.query-cat-name')?.textContent;
            if(query) {
                const noResMessages = {
                    en: `We couldn't find any matches for '${query}'. Please check your spelling or try again using a different search term.`,
                    fr: `Aucun résultat trouvé pour « ${query} ». Vérifiez l'orthographe ou essayez avec un autre terme de recherche.`
                };
                noRes.textContent = noResMessages[window.fsLang] || noResMessages.en;
                const pageTitle = document.querySelector('.fs-page-title-container');
                if (pageTitle && pageTitle.style) {
                    pageTitle.style.display = 'none';
                }
                appParent?.classList?.add('fs-no-results-page');
            }
        }
    });

    SerpOptions.registerHook('serp-filters', ({filters, element}) => {
        applyFilterSizeConversion(element);
        applyRemovableTagSizeConversion(element);
        // the desktop chips live inside the filters panel ("FILTRES APPLIQUÉS"),
        // so they are reached from here as well as from serp-removable-tags
        applyRemovableTagPriceFormat(element);
        applyTagFilterLabelFormat(element);
        if(window.innerWidth>768){
            const removableTagsContainer = element.querySelector('.fs-filters-removable-tags');
            const applyAllButton = element.querySelector('.apply-all-button');

            if (removableTagsContainer && applyAllButton && !removableTagsContainer.contains(applyAllButton)) {
                removableTagsContainer.appendChild(applyAllButton);
            }
            let pageParent = element.closest('#fs-ssr-app-content');
            element.addEventListener('mouseenter', () => {
                element.addEventListener('mouseleave', () => {
                    if(isFiltersOpen) {
                        element.querySelector('.close-button')?.click();
                        isFiltersOpen = false;
                    }
                });
            });
        }

        const filterPanel = element.querySelector('.filters-container-top-panel');
        if (filterPanel && !filterPanel.querySelector('.fs-filter-close-x')) {
            const closeXBtn = document.createElement('button');
            closeXBtn.className = 'fs-filter-close-x';
            closeXBtn.setAttribute('aria-label', 'Close filters');
            closeXBtn.style.cssText = 'position:absolute;top:10px;right:10px;background:none;border:none;cursor:pointer;z-index:10;padding:5px;color:#000;';
            closeXBtn.innerHTML = `
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M15 5L5 15" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
                <path d="M5 5L15 15" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
              </svg>
            `;
            closeXBtn.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                const nativeCloseBtn = element.querySelector('.close-button');
                if (nativeCloseBtn) nativeCloseBtn.click();
            });
            filterPanel.style.position = 'relative';
            filterPanel.prepend(closeXBtn);
        }

        if (window.innerWidth <= 768 && !element.querySelector('.fs-filter-close-x')) {
            const closeXBtn = document.createElement('button');
            closeXBtn.className = 'fs-filter-close-x';
            closeXBtn.setAttribute('aria-label', 'Close filters');
            closeXBtn.innerHTML = `
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M15 5L5 15" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
                <path d="M5 5L15 15" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
              </svg>
            `;
            closeXBtn.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                const nativeCloseBtn = element.querySelector('.fs-modern-filters-close-button') || element.querySelector('.close-button');
                if (nativeCloseBtn) {
                    nativeCloseBtn.click();
                }
            });
            element.prepend(closeXBtn);
        }

        enhanceMobileFilters(element);
    });
    SerpOptions.registerHook('serp-top-page', ({ element }) => {
        // console.log('el', element);
        let titleCont = element.closest('#fs-serp-app')?.querySelector('.fs-page-title-container');
        let pageParent = element.closest('#fs-ssr-app-content');
        if(titleCont) {
            if(pageParent && pageParent.classList.contains('fs-search')) {
                let query = pageParent?.querySelector('.query-cat-name')?.textContent;
                let searchCount = pageParent?.querySelector('.fs-num-results')?.textContent;
                if(query && searchCount) {
                    titleCont.querySelector('.title').textContent = `We found ${searchCount} for '${query}'.`;
                    titleCont.classList.add('fs-serp');
                    moveElementToTop(titleCont);
                }
            }
            else {
                moveElementToTop(titleCont);
            }
            addCategoryDescription(titleCont);
        }
        // Only run on mobile
        if (window.innerWidth <= 770) {
            //Handle open filter button on mobile
            const filterButton = element.querySelector('.filters-button-wrapper');
            if (filterButton && !filterButton.classList.contains('cstm-event-trigger')) {
                filterButton.classList.add('cstm-event-trigger');
                filterButton.addEventListener('click', function () {
                    const serpApp = filterButton.closest('#fs-serp-app');
                    if (!serpApp) return;
                    const modalOverlay = serpApp.querySelector('.fs-modal-overlay');
                    if (!modalOverlay) return;
                    const allFilters = serpApp.querySelectorAll('.fs-is-filters-open');
                    allFilters.forEach(openFilter => {
                        openFilter.classList.remove('fs-is-filters-open');
                        openFilter.querySelector('.category-items')?.classList.add('collapsed');
                        openFilter.querySelector('.arrow')?.classList.add('rotate');
                    });
                });
            }
            //End

            setTimeout(() => {
                const sortByOptions = element.querySelector('.fs-custom-options');

                if (sortByOptions && !sortByOptions.querySelector('.fs-sortby-header')) {
                    // Create header div
                    const headerDiv = document.createElement('div');
                    headerDiv.classList.add('fs-sortby-header');

                    // Create text
                    const title = document.createElement('span');
                    title.classList.add('fs-sortby-title');
                    title.textContent = 'sortBy';

                    // Create close button
                    const closeButton = document.createElement('button');
                    closeButton.classList.add('fs-sortby-close');
                    closeButton.innerHTML = `
                    <svg width="20px" height="20px" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 352 512">
                        <path fill="currentColor" d="M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"/>
                    </svg>
                    `;

                    closeButton.addEventListener('click', () => {
                    document.querySelector('html').click();
                    });

                    // Append elements
                    headerDiv.appendChild(title);
                    headerDiv.appendChild(closeButton);
                    sortByOptions.prepend(headerDiv);
                }
            }, 200);
        }

        // const filtersBtn = pageParent.querySelector('.hide-filters-button');
        // filtersBtn.addEventListener('mouseenter', () => {
        //     if (!isFiltersOpen) {
        //         filtersBtn.click();
        //         isFiltersOpen = true;
        //     }
        // });
        // pageParent.addEventListener('mouseleave', () => {
        //     if (isFiltersOpen) {
        //         filtersBtn.click();
        //         isFiltersOpen = false;
        //     }
        // });


    });
    SerpOptions.registerHook('serp-removable-tags', ({ tags, element }) => {
        //remove hover effect
        applyRemovableTagSizeConversion(element);
        applyRemovableTagPriceFormat(element);
        applyTagFilterLabelFormat(element);
    });
}

  let isFiltersOpen = false;
  let isSortOpen = false;

if (window.SerpOptions) {
    hooks();
} else {
    window.addEventListener('fast-serp-ready', function () {
        hooks();
    });
}
async function updateminicart() {
    const shopifyRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    const localeRoot = shopifyRoot !== '/' ? shopifyRoot : (/^\/fr(\/|$)/i.test(window.location.pathname) ? '/fr/' : '/');
    const res = await fetch(`${localeRoot}?render_id=header-minicart`);
    const text = await res.text();

    const html = document.createElement("div");
    html.innerHTML = text;

    // Update cart drawer
    const newcart = html.querySelector("#CartDrawer").innerHTML;
    document.querySelector("#CartDrawer").innerHTML = newcart;

    // Replace the entire cart icon (SVG + badge)
    const newCartIcon = html.querySelector("#cart-icon-bubble");
    const currentCartIcon = document.querySelector("#cart-icon-bubble");

    if (newCartIcon && currentCartIcon) {
        currentCartIcon.replaceWith(newCartIcon);
    }

    document.querySelector("cart-drawer.drawer").classList.remove("is-empty");
}
window.addEventListener('fs-custom-events-product-added-to-cart', async (e) => {
    await updateminicart();
    let cartParent = document.querySelector('cart-drawer.drawer');
    if(cartParent) {
        cartParent.classList.add('active');
    }
});
window.addEventListener('fs-rec-custom-events-product-added-to-cart', async (e) => {
    await updateminicart();
    let cartParent = document.querySelector('cart-drawer.drawer');
    if(cartParent) {
        cartParent.classList.add('active');
    }
});

function autocompleteHooks() {
    FastAutocomplete.registerHook('render-autocomplete-product-item', ({ product, index, element }) => {
        const infoEl = element.querySelector('.fs-product-info');
        if (infoEl && product.v) {
            element.querySelectorAll('.fs-product-vendor').forEach(e => {
                e.remove()
            });
            const vendorEl = document.createElement('div');
            vendorEl.classList.add('fs-product-vendor');
            vendorEl.textContent = product.v;
            infoEl.appendChild(vendorEl);
        }
    });
}

// execution here
if (window.FastAutocomplete) {
    autocompleteHooks();
} else {
    window.addEventListener('fast-autocomplete-ready', function () {
        autocompleteHooks();
    });
}